import React, { useState } from "react";
import { ScaleFactorProvider } from "arkh";
import { graphql, useMutation } from "react-relay";
import { EmployeeRoleEditEmployeesDialog } from "@/src/features/EmployeeRoles/EmployeeRoleEdit/EmployeeRoleEditEmployeesDialog";
import { StorecastEmployeeRoleDialogMutation } from "./__generated__/StorecastEmployeeRoleDialogMutation.graphql";

type Props = {
  roleId: string;
  roleName: string;
  teamId: string;
  teamName: string;
  teamColor: string | null;
  employeeIds: string[];
  onClose: () => void;
};

export function StorecastEmployeeRoleDialog(props: Props) {
  const [employeeIds, setEmployeeIds] = useState([...props.employeeIds]);

  const [assignEmployeesToRole] =
    useMutation<StorecastEmployeeRoleDialogMutation>(graphql`
      mutation StorecastEmployeeRoleDialogMutation(
        $roleId: ID!
        $employeeIds: [ID!]!
      ) {
        assignEmployeesToRole(roleId: $roleId, employeeIds: $employeeIds) {
          role {
            id
            employeeIds
            employeeCount
            employees {
              id
              name
              ...Avatar_employee
            }
          }
        }
      }
    `);

  const setAssignEmployeesIds = (newEmployeeIds: string[]) => {
    setEmployeeIds(newEmployeeIds);
    assignEmployeesToRole({
      variables: {
        roleId: props.roleId,
        employeeIds: newEmployeeIds,
      },
    });
  };

  return (
    <ScaleFactorProvider value={1}>
      <EmployeeRoleEditEmployeesDialog
        visible
        teamId={props.teamId}
        assignEmployeesIds={employeeIds}
        setAssignEmployeesIds={setAssignEmployeesIds}
        onClose={props.onClose}
        title={props.roleName}
        subtitle={props.teamName}
        teamColor={props.teamColor}
      />
    </ScaleFactorProvider>
  );
}
